import { patientServices } from "../../Services/PatientServices/patient.services";


const patientListing = async () => {
    let response = await patientServices.patientList();
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const patientDetail = async (id) => {
    let response = await patientServices.patientDetails(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const patientCreate = async () => {
    let post = {
        "name": "Test Patient",
        "phonenumber": "989498799",
        "uh_id": "#HID89",
        "email": null,
        "dob": "12-12-1995",
        "gender": "male",
        "blood_group":null,
        "address":"Ludhiana",
        "city":"Ludhiana",
        "state":"Punjab",
        "patient_status":"admitted",
        "summary":null,
        "insurance":1,
        "relation_type":null,
        "relative_name":null,
        "relative_phonenumber":null,
        "hospital": [10]
    }
    let response = await patientServices.patientCreate(post);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const patientUpdate = async (id) => {
    let response = await patientServices.patientUpdate(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const patientDelete = async (id) => {
    let response = await patientServices.patientDelete(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const patientController = {
    patientListing,
    patientDetail,
    patientCreate,
    patientUpdate,
    patientDelete
};

export default patientController;
